import React, { useEffect } from 'react'
import Button from './Button'
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { apiCallBegan } from '../store/api';
import { refreshURL } from '../store/slices/cache'
import Input from './Input';

const SQCurrent = ({ potential, setStep, pain_points, values }) => {
  let dispatch = useDispatch()
  let { register, errors, setValue, handleSubmit } = useForm()

  useEffect(() => {
    if (potential) {
      setValue('current_model', potential?.metrics?.current_model)

      Object.keys(pain_points).forEach(et => {
        setValue(`pain_points.${et}`, potential?.metrics?.pain_points?.[et])
      })
      Object.keys(values).forEach(et => {
        setValue(`values.${et}`, potential?.metrics?.values?.[et])
      })
    }
  }, [potential])

  let submit = (data) => {
    dispatch(apiCallBegan({ url: `/business/edits/${potential?._id}`, method: 'PUT', data: {
      'metrics.current_model': data.current_model,
      'metrics.pain_points': data.pain_points,
      'metrics.values': data.values
    }, showSpinner: true, onSuccessFunc: () => refreshURL(`/business/withContacts/${potential?._id}`), onExtFunc: () => setStep(3) }))
  }

  return <div className='sSlide'>
    <form className='compCard'  onSubmit={handleSubmit(submit)}>
    <h2 className='sqTitle'>Current model to service AV requests</h2>
        <textarea  name="current_model" id="current_model" ref={register} placeholder='Current model to service AV requests' >

        </textarea>
        <h2 className='sqTitle'>Most Common Pain Points</h2>
        <div className="painRow">
            {Object.keys(pain_points).map((k,i) => <Input  className='field-check-rev long'  type='checkbox' _ref={register}   name={`pain_points.${k}`} label={`${k.toUpperCase()} - ${pain_points[k][0]}`} />)}
        </div>
        <h2 className='sqTitle'>Company Values</h2>
        <div className="painRow">
            {Object.keys(values).map((k,i) => <Input  className='field-check-rev long'  type='checkbox' _ref={register}   name={`values.${k}`} label={`${k.toUpperCase()} - ${values[k][0]}`} />)}
        </div>
        <div className="buttons">
      <Button className='btn-4 ' noButton onClick={() => setStep(1)} >Back</Button>
      <Button className='btn-4 highLight '>Continue</Button>
    </div>
    </form>


  </div>
}

export default SQCurrent